var _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalPlantHeatGenOutdoor = function SvgPSignalPlantHeatGenOutdoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "342.1,46.1 342.1,55.1 560.1,55.1 560.1,106.1",
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPSignalPlantHeatGenOutdoor;